








































































































































































import { Component, Vue, Watch, Prop } from 'vue-property-decorator';

import { WeeklyMeeting, CoreTeamMeeting, MinistryMeeting, OtherActivities } from '../common/form-type.interface';

import util from '../common/utility';
import axios from 'axios';

@Component({})
export default class extends Vue {
    @Prop() public weeklyMeeting: WeeklyMeeting | any;
    @Prop() public coreTeamMeeting: CoreTeamMeeting | any;
    @Prop() public discipleshipCellMeeting: MinistryMeeting | any;
    @Prop() public otherMinistryMeeting: MinistryMeeting | any;
    @Prop() public otherActivities: OtherActivities | any;

    @Prop() public month: number | any;
    @Prop() public year: number | any;

    public errorMessage: string[] = [];

    public disableSubmit = (
        !this.weeklyMeeting.isValid ||
        !this.coreTeamMeeting.isValid ||
        !this.discipleshipCellMeeting.isValid ||
        !this.otherMinistryMeeting.isValid
    );

    public success = '';

    public get ErrorLength() {
        return this.errorMessage.length;
    }

    public closeError(e: Event) {
        this.errorMessage = [];
    }

    public closeSuccess(e: Event) {
        this.success = '';
    }

    public submitReport() {
        const month = util.getMonth(+this.month);
        const user = util.initUser();

        if (
            user && user.pg_id && user.leader_id &&
            confirm('Are you sure you want to submit report for ' + month + ' ' + this.year)
        ) {
            this.disableSubmit = true;

            axios({
                method: 'post',
                url: util.api('user/data'),
                data: {
                    pg_id: +user.pg_id,
                    leader_id: +user.leader_id,
                    month: this.month,
                    year: this.year,
                    weeklyMeetings: this.weeklyMeeting.data,
                    coreTeamMeetings: this.coreTeamMeeting.data,
                    discipleshipCellMeetings: this.discipleshipCellMeeting.data,
                    otherMinistryMeetings: this.otherMinistryMeeting.data,
                    otherActivities: this.otherActivities.data
                }
            })
            .then( (response: any) => {
                this.errorMessage = [];
                this.success = response.data;

                delete localStorage.data;

                util.eventBus.$emit('image-popup');
            })
            .catch( (error: any) => {
                this.errorMessage = [].concat(error.response.data);
                this.disableSubmit = false;
            });
        }
    }
}

